// extracted by mini-css-extract-plugin
export default {"Active":"AddNewJournal_Active__qUtLD"};